import { now } from "lodash";

export function run(){
    return {
        init(_class, url){
            $( _class ).sortable({
                stop: function( event, ui ) {
                    var sort = [];
                    $(this).find('.item').each(function(){
                        sort.push($(this).data('id'));
                    });

                    axios.put(url, {
                        sort: sort
                    });
                }
              });
            $( _class ).disableSelection();
        }
    }
}
